import React, { useState, useEffect } from "react";
import { useRoutes, useLocation } from "react-router-dom";
import { AuthLayout, NonAuthLayout } from "../layout/PageLayout";
import { PRIVATE_ROUTES, PUBLIC_ROUTES } from "./routes";
import ScrollToTop from "./scrollToTop";
import NetworkStatusMonitor from "components/layout/networkMonitor";
import { useQuery } from "@apollo/client";
import { IS_LOGGED_IN } from "GraphQL/Queries";
import authStore from "stores/authStore";

const routes = [
  {
    element: <NonAuthLayout />,
    children: PUBLIC_ROUTES,
  },
];

const PublicRouteWrapper = () => {
  return useRoutes(routes);
};

const PrivateRouteWrapper = () => {
  const routes = useRoutes(PRIVATE_ROUTES);
  return routes;
};

const Pages = () => {
  const { isAuthenticated, setIsAuthenticated } = authStore;

  const location = useLocation();

  const { data: logReport, loading } = useQuery(IS_LOGGED_IN, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      if (data?.isLoggedIn) {
        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false);
      }
    },
  });

  return loading ? (
    <></>
  ) : isAuthenticated || logReport?.isLoggedIn ? (
    <AuthLayout>
      <ScrollToTop />
      <NetworkStatusMonitor />
      <PrivateRouteWrapper key={location.pathname} />
    </AuthLayout>
  ) : (
    <>
      <ScrollToTop />
      <PublicRouteWrapper key={location.pathname} />
    </>
  );
};

export default Pages;
